import api from "./client";

export function getRegistrations(status = "pending") {
  return api.get("/platform/registrations", { params: { status } }).then((res) => res.data);
}

export function approveRegistration(id, payload) {
  return api.post(`/platform/registrations/${id}/approve`, payload).then((res) => res.data);
}

export function rejectRegistration(id, payload) {
  return api.post(`/platform/registrations/${id}/reject`, payload).then((res) => res.data);
}

export function updateRegistrationVerification(id, payload) {
  return api.post(`/platform/registrations/${id}/verification`, payload).then((res) => res.data);
}
